const POPUP_KEY = (hotspotId, userId) => `nq_${hotspotId}_popup_seen_${userId || "anon"}`;

export function hasSeenHotspotPopup(hotspotId, userId) {
  try {
    return localStorage.getItem(POPUP_KEY(hotspotId, userId)) === "1";
  } catch {
    return false;
  }
}

export function markHotspotPopupSeen(hotspotId, userId) {
  try {
    localStorage.setItem(POPUP_KEY(hotspotId, userId), "1");
  } catch {
  }
}

export function clearHotspotPopupSeen(hotspotId, userId) {
  try {
    localStorage.removeItem(POPUP_KEY(hotspotId, userId));
  } catch {
  }
}

export function hasSeenDeskPopup(userId) {
  return hasSeenHotspotPopup("desk", userId);
}

export function markDeskPopupSeen(userId) {
  markHotspotPopupSeen("desk", userId);
}

export function clearDeskPopupSeen(userId) {
  clearHotspotPopupSeen("desk", userId);
}

export function hasSeenBookshelfPopup(userId) {
  return hasSeenHotspotPopup("bookshelf", userId);
}

export function markBookshelfPopupSeen(userId) {
  markHotspotPopupSeen("bookshelf", userId);
}
